<template>
	<div class="scanrecord">
    <v-header></v-header>
      <ul>
        <li v-for="item in scancon">{{item}}</li>
      </ul>
	</div>
</template>

<script>
import { updateUserInfo, updateBasicInfo,getLoginUser } from "../../api/index.js";
import Axios from "axios";
import Qs from "qs";
import header from "../../components/header";
export default {
  name: "scanRecord",
  inject: ["reload"],
  props:["scanrecord"],
  data() {
    return {
      scancon:[]
    };
  },
  components:{
    "v-header":header
  },
  created(){
       
  },
  mounted() {
    this.scancon = this.scanrecord;
  },
  methods: {
    
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/m_page/myAccount/scanRecord.vue